import { setLocalStorageItem, removeLocalStorageItem } from '@fastcampus/browser-util';
import { setAccessToken } from '@fastcampus/browser-support';

import { checkToken, signIn as commonSignIn, signOut as commonSignOut } from '@fastcampus/browser-support';

// TODO: get configs by common module
const config = {
  ACCESS_TOKEN_KEY: 'fc-access-token',
  CLIENT_ID: 'fc:client:www',
  AUTH_SCOPE: 'www',
  AUTH_SERVER: process.env.FC_AUTH_URL,
};

const AUTH_OPTS = {
  tokenKey: config.ACCESS_TOKEN_KEY,
  authUrl: config.AUTH_SERVER,
  option: {
    client_id: config.CLIENT_ID,
    response_type: 'token',
    redirect_uri: window.location.href.replace(window.location.hash, ''),
    scope: config.AUTH_SCOPE,
  },
  isHistoryReplaceRequired: false,
  dest: '/',
};

const mixin = {
  methods: {
    data() {
      return {
        isAuthorized: false,
      };
    },
    authorize(signIn, { message, popupId, additionalOpts } = {}) {
      try {
        const token = checkToken(config.ACCESS_TOKEN_KEY);
        setAccessToken(token);
        setLocalStorageItem(config.ACCESS_TOKEN_KEY, token);
        this.isAuthorized = true;
      } catch (err) {
        setAccessToken();
        removeLocalStorageItem(config.ACCESS_TOKEN_KEY);
        this.isAuthorized = false;
        if (signIn) {
          if (message) AUTH_OPTS.option.message = message;
          if (popupId) AUTH_OPTS.option.popupId = popupId;

          commonSignIn({ ...AUTH_OPTS, ...additionalOpts });
        }
      }
    },
    signIn() {
      commonSignIn({ ...AUTH_OPTS, dest: '/authorize' });
    },
    getSignUpUrl() {
      const param = new URLSearchParams(AUTH_OPTS.option);
      window.location.href = `${config.AUTH_SERVER}/sign-up?${param}`;
    },
    rejectAuthorize(returnTo) {
      setAccessToken();
      removeLocalStorageItem(config.ACCESS_TOKEN_KEY);
      commonSignOut({ ...AUTH_OPTS, returnTo });
    },
  },
};

export default mixin;
